import i18n from '@src/common/lib/i18n'
const DIC = {
  isIndoorList: [{
    label: "是",
    value: "1"
  }, {
    label: "否",
    value: "0"
  }],
  stateList: [{
    label: "在线",
    value: "1"
  }, {
    label: "离线",
    value: "0"
  },
  {
    label: "故障",
    value: "2"
  }],
  deviceType:[{
    label: "电气火灾监控设备",
    value: "0"
  }],
  businessName:[{
    label:'深圳市中电电力厂商',
    value: "0"
  }],
}
export const tableOption = function (that) {
  return {
    add: '新增',
    edit: '修改',
    view: '详情',
    emptyText: that.$t("deviceAccess.message.nodata"),
    stripe: true,
    maxHeight: "100%",
    //addFormSlot: true,
    page: true,
    align: "center",
    menuAlign: "center",
    labelSuffix: '：',
    header: false,
    selection: true,
    delBtn: false,
    editBtn: false,
    labelWidth: '120px',
    dialogWidth: '900px',
    menuBtn: false,
    column: [{
      label: '设备名称',
      prop: 'thirdDeviceName',
      labelWidth: 100,
      search: true,
      span: 8,
      clearable: true,
      overHidden: true,
      rules: [{
        required: true,
        message: that.$t('cameraList.placeholder.enterName'),
        trigger: 'blur'
        },
      {
        min: 1,
        max: 64,
        message: that.$t('cameraList.placeholder.lengthLess'),
        trigger: 'blur'
      }
      ]
    },
    {
      label: "设备IP",
      //search: true,
      prop: 'deviceHost',
      labelWidth: 110,
      overHidden: true,
      span: 8,
      rules: [{
        required: true,
        message: "请输入设备IP",
        trigger: 'blur'
      },],

    },
    // {
    //   label: "systemId",
    //   //search: true,
    //   prop: 'systemId',
    //   labelWidth: 110,
    //   overHidden: true,
    //  // hide: true,
    //   editDisplay: false,
    //   viewDisplay: true,
    //   addDisplay: false,
    //   span: 8,
    // },
    {
      label: "设备id",
      search: true,
      prop: 'thirdDeviceId',
      labelWidth: 110,
      span: 8,
      rules: [{
        required: true,
        message: "请输入设备id",
        trigger: 'blur'
      },],

    },
    {
      label: "设备端口",
      prop: 'devicePort',
      labelWidth: 110,
      span: 8,
      hide:true,
      overHidden: true,
      placeholder: '请输入设备端口 ',
      rules: [{
        required: true,
        message: "请输入设备端口",
        trigger: 'blur'
      },],

    },
      // 以及属性 可改
      {
        label: "厂商名称",
        prop: 'factoryName',
        labelWidth: 100,
        span: 8,
        overHidden:true, 
        display: false
      },
    {
      label: "从机地址",
      prop: 'slaveId',
      labelWidth: 110,
      overHidden: true,
      span: 8,
      hide:true,
      editDisplay: false,
      placeholder: '请输入从机地址 ',
      rules: [{
        required: true,
        message: "请输入从机地址",
        trigger: 'blur'
      },],

    },
    {
      label: "主设备类型",
      prop: 'deviceType',
      labelWidth: 110,
      overHidden: true,
      span: 8,
      type: 'select',
      dicData: DIC.deviceType,
      rules: [{
        required: true,
        message: "请输入主设备类型",
        trigger: 'blur'
      },],
      mock: {
        type: 'dic'
      },  
      formatter: function (row, value) {
        return Number(value) === 21 ? '电气火灾监控设备' :''
      },
      viewFormatter: (row, value) => {
        return Number(value) === 21 ? '电气火灾监控设备':''
      },

    },
    {
      label: "设备状态",
      prop: 'status',
      type: 'select', 
      display:false,
      editDisplay: false,
      viewDisplay: true,
      addDisplay: false,
      span: 8,
      labelWidth: 100,
      dicData: DIC.stateList,
      rules: [{
        required: true,
        message: "请选择",
        trigger: 'change'
      },],
      mock: {
        type: 'dic'
      },
      formatter: function (row, value) {
        return Number(value) === 1 ? '在线' : Number(value) === 2 ? '故障' : "离线"
      },
      viewFormatter: (row, value) => {
        return Number(value) === 1 ? '在线' : Number(value) === 2 ? '故障' : "离线"
      },
    },
    {
      label: "是否在室内",
      prop: 'isIndoor',
      labelWidth: 100,
      type: 'select',
      span: 8,
      overHidden: true,
     addDisplay:false,
      formslot: true,
      rules: [{
        required: true,
        message: "是否在室内",
        trigger: 'blur'
      },],
      formatter: function (row, value) {
        return Number(value) === 1 ? '室内' : "室外"
      },
      viewFormatter: (row, value) => {
        return Number(value) === 1 ? '室内' :"室外"
      },
    },
    
    {
      label: "所属楼栋",
      prop: 'buildingName',
      labelWidth: 100,
      span: 8,
      hide:false,
      overHidden: true,
      editDisplay: false,
      addDisplay:false,
      
      formslot: true,
      viewDisplay: true,
      //hide:true,
      rules: [{
        required: true,
        message: "请选择所属楼栋",
        trigger: 'blur'
      },],
    },
    {
      label: that.$t('cameraList.label.lng'),
      prop: 'longitude',
      labelWidth: 100,
      formslot: true,
      span: 8,
      hide:true,
      addDisplay:false,
      viewDisplay:true,
     // viewDisplay: false,
      clearable: true,
      rules: [{
        required: true,
        message: that.$t('cameraList.placeholder.enterLng'),
        trigger: 'change'
      },
      {
        pattern: /^[-+]?(0?\d{1,2}|0?\d{1,2}\.\d{1,10}|1[0-7]?\d{1}|1[0-7]?\d{1}\.\d{1,10}|180|180\.0{1,10})$/,
        message: that.$t('cameraList.message.numberMorn'),
        trigger: 'change'
      }
      ]
    },
    {
      label: that.$t('cameraList.label.lat'),
      prop: 'latitude',
      labelWidth: 100,
      addDisplay:false,
      formslot: true,
      span: 8,
      viewDisplay: false,
      hide:true,
      clearable: true,
      rules: [{
        required: true,
        message: that.$t('cameraList.placeholder.enterLat'),
        trigger: 'change'
      },
      {
        pattern: /^[-+]?([0-8]?\d{1}|[0-8]?\d{1}\.\d{1,10}|90|90\.0{1,10})$/,
        message: that.$t('cameraList.message.numberMorns'),
        trigger: 'change'
      }
      ]
    },
    {
      label: "高度",
      prop: 'height',
      labelWidth: 100,
      hide:true,
      viewDisplay:true,
      disabled: true,
      // placeholder: ' ',
      span: 8,
      rules: [{
        required: true,
        message: "请输入高度",
        trigger: 'blur'
      },],
    },
    {
      label: "宽度",
      prop: 'width',
      hide:true,
      viewDisplay:true,
      labelWidth: 100,
      disabled: true,
      // placeholder: '',
      span: 8,
      rules: [{
        required: true,
        message: "请输入宽度",
        trigger: 'blur'
      },],

    },
    {
      label: "横坐标",
      prop: 'abscissa',
      labelWidth: 100,
      hide:true,
      viewDisplay:true,
      disabled: true,
     // placeholder: ' ',
      span: 8,
      rules: [{
        required: true,
        message: "请输入横坐标",
        trigger: 'blur'
      },],
    },
    {
      label: "纵坐标",
      prop: 'ordinate',
      hide:true,
      viewDisplay:true,
      labelWidth: 100,
      disabled: true,
      // placeholder: '',
      span: 8,
      rules: [{
        required: true,
        message: "请输入纵坐标",
        trigger: 'blur'
      },],

    },
   
    {
      label: "设备描述",
      type: 'textarea',
      prop: 'thirdDeviceDesc',
      labelWidth: 100,
      minRows: 3,
      addDisplay:false,
      maxlength: 120,
      span: 24,
      clearable: true,
    },
  
    ]
  }
}
